import * as UnitTimes from 'uom-units/src/unit-times.ts';
import { PoundForce } from 'uom-units/src/units/force.ts';
import { Inch } from 'uom-units/src/units/length.ts';

export const PoundInch = UnitTimes.forceByLength(
    'PoundInch',
    PoundForce,
    Inch,
);
